"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import { IndustryChooseProps } from "./types";
import { WhyChooseCard } from "@/components/screen/global-components/why-choose";
import { Typography } from "@/components/ui/typography";

const IndustryChoose = ({ content, className }: IndustryChooseProps) => {
  const { whyChooseTitle, whyChooseDescription, whyChooseItems } = content;

  if (!whyChooseTitle && !whyChooseDescription && !whyChooseItems?.length) {
    return null;
  }

  const items =
  whyChooseItems
    ?.map((item) => item?.fields?.longText)
    .filter(Boolean) || [];


  return (
    <section className={cn("section bg-white", className)}>
      <div className="container py-12 lg:pt-20 mx-auto">
        <div className="grid grid-cols-1 text-center place-content-start gap-4 lg:gap-2">
          <Typography
            variant="heading4"
            className="text-semantic-text-primary lg:text-grey-800 lg:font-medium lg:leading-[135%]"
          >
            <h2>{whyChooseTitle}</h2>
          </Typography>
          <Typography
            variant="subHeadingSm"
            className="text-semantic-text-secondary lg:gray-600 lg:text-base lg:leading-[150%]"
            asChild
          >
            <p>{whyChooseDescription}</p>
          </Typography>
        </div>
        <WhyChooseCard items={items} className="mt-6 lg:mt-12" />
      </div>
    </section>
  );
};

export default memo(IndustryChoose);
